export default __webpack_public_path__ + "038e993.png";